import { AdapterBase } from '@navix/utils/adapter'
import { User } from '../domain/user.model'
import { UserForm } from '../domain/user-form.model'

export class ToUserAdapter extends AdapterBase<unknown, User | User[]> {}
export class FromUserAdapter extends AdapterBase<User | UserForm, unknown> {}
